export default "__VITE_ASSET__a499e490__"